export const API_ENDPOINTS = {
  USERS: 'users',
  AUTH: 'auth',
  NIVEDAN: 'nivedan',
  NIVEDAN_ASSIGN: 'nivedan/asign',
  CATEGORY: 'nivedan/attributes',
  STREAMAPI: 'https://konnectprodstream5.knowlarity.com:8200/update-stream/a6746cd9-84cc-42d6-9b85-c6607d42a394/konnect?source=router',
  PINCODE: 'phil/',
  RITWIKS: 'phil/ritwiks',
  USER: 'user',
  PLAY_AUDIO: 'call/recording',
  CALL_LIST: 'call',
  REQUEST_OTP: 'guest-user/request-otp',
  VERIFY_OTP: 'guest-user/verify-otp',
  GUEST_USERS: 'guest-user',
  GUEST_ASSIGN_NIVEDAN: 'guest-user/assign-nivedan',
  STRIKE_COMMENT: 'nivedan/comment/strike-out',
  RECORD_CALL_SYNC: 'nivedan/sync-call-recording',
  DRAFT_NIVEDAN: 'nivedan/draft',
  // DRAFT_NIVEDAN_SUBMIT: 'nivedan/{nivedanId}/submit'
};

export const TELECMI_API_ENDPOINTS = {
  INCOMING_ANSWERED: '/answered',
  INCOMING_MISSED: '/missed',
  OUTGOING_ANSWERED: '/out_answered',
  OUTGOING_MISSED: '/out_missed',
  PLAY_RECORD: '/call/recording',
  VOICEMAIL: '/voicemail'
}

